import type { MutationSettings } from '@customTypes/index';
import { useMutation } from '@tanstack/react-query';

import type { UpdatePhotoItemParams } from '@/shared/api/requests/photo/update-photo-item/request';
import { updatePhotoItem } from '@/shared/api/requests/photo/update-photo-item/request';

export const useUpdatePhotoItemMutation = (
  settings?: MutationSettings<UpdatePhotoItemParams, typeof updatePhotoItem>
) =>
  useMutation({
    mutationKey: ['updatePhotoItem'],
    mutationFn: ({ params, config }) =>
      updatePhotoItem({
        params,
        config
      }),
    ...settings?.options
  });
